/* eslint-disable @typescript-eslint/ban-ts-comment */
import Button from "../../Shared/Button"
import Input from "../../Shared/Input"
import TextArea from "../../Shared/TextArea"
import { useFormik } from "formik";
import { useMutation, useQuery } from "@tanstack/react-query";
import * as Yup from "yup";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../../utils/consts";
import Spinner from "../../Shared/Spinner";
import { toast } from 'react-toastify';
import { queryClient } from "../../../main";
import Upload from "../../Shared/Upload";
import { useParams, useNavigate } from "react-router-dom";
import { GetCertificateById } from "../../../api/Certificates/GetCourseById";
import { EditCertificate } from "../../../api/Certificates/EditCertificate";
import { AddNewCertificate, AddCertificateDTO } from "../../../api/Certificates/AddCertificate";
const validationSchema = Yup.object({
  name: Yup.string()
    .required("Certificate name is required"),
  description: Yup.string()
    .required("Certificate description is required"),
  img_url: Yup.string()
    .required("Display Image is required"),
});

const AddCertificate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { id } = useParams()
  const certificateId = id || ''
  const { data: CertificateById, isLoading: isCourseLoading } = useQuery({
    queryFn: () => GetCertificateById(certificateId),
    queryKey: ["courses", certificateId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!id
  });
  const certificates = CertificateById?.data
  const navigate = useNavigate()
  const { mutate, error, isPending } = useMutation({
    mutationFn: AddNewCertificate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["certificates"] });
      toast.success("Certificate Added successfully");
      formik.resetForm();
      onSuccess && onSuccess();
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });
  const { mutate: editMutate, isPending: isEditPending } = useMutation({
    //@ts-ignore
    mutationFn: (data: AddCertificateDTO) => EditCertificate(data, certificateId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["certificates"] });
      toast.success("Certificate Edited successfully");
      formik.setSubmitting(true);
      navigate('/dashboard/exam-maker')
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });
  
  const formik = useFormik({
    initialValues: {
      name: certificates?.name || "",
      description: certificates?.description || "",
      img_url: certificates?.img_url || "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      const formattedValues: AddCertificateDTO = {
        ...values,
      };

      if (id) {
        editMutate(formattedValues);
      } else {
        mutate(formattedValues);
      }
    },
  });

  const handleimgUrlUpload = (url: string) => {
    formik.setFieldValue('img_url', url);
  };


  if (isCourseLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <form onSubmit={formik.handleSubmit}
      className="pt-5">
      <div className="flex justify-between mb-6">
        <h1 className="text-burntBlack font-bold text-[32px] mt-5">{id ? 'Edit certificate' : 'Add new certificate'}</h1>
      </div>
      <div className="p-8 rounded-3xl shadow bg-white border border-black/15 min-h-[70vh] flex gap-16">
        <div className="w-full">
          <h1 className="mb-2.5 font-bold text-2xl">Certificate info</h1>
          <p className="text-lightGray font-medium">Add Certificate details to help students discover your certificate and better
            understand what they will learn. what they will need and expect</p>
          <div className="space-y-7 pt-8">
            <Input
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : ""
              }
              className="text-lg font-semibold"
              inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              title="Certificate Title"
              placeholder=""
              name="name"
              type="text"
            />
            <TextArea
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && formik.errors.description
                  ? formik.errors.description
                  : ""
              }
              name="description" title="Certificate Description" placeholder="" inputStyles="!bg-[#F5F6F8] !h-[224px] border-black/15"
            />
            <Upload folder="courses_images" onFileUploaded={handleimgUrlUpload}>
              <Input
                upload={true}
                className="text-lg font-semibold"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                placeholder=""
                title="Certificate Image"
                name="img_url"
                type="text"
                value={formik.values.img_url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.img_url && formik.errors.img_url
                    ? formik.errors.img_url
                    : ""
                }
              />

            </Upload>
          </div>
          <div className="space-y-7 pt-8 w-full">
            {error instanceof AxiosError && (
              <span className="text-red-500 font-bold text-lg">
                {error?.response?.data?.message || "An error occurred"}
              </span>
            )}
            <Button className="!h-14 w-full !text-lg font-bold rounded-md !bg-[#4379EE] hover:!bg-primary" variant="primary" type={ButtonTypes.SUBMIT}
              disabled={formik.isSubmitting || isPending || isEditPending}
            >Done           {isPending || isEditPending ? (
              <Spinner />) : ('')}
            </Button>

          </div>
        </div>

      </div>
    </form>
  )
}

export default AddCertificate